import React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLanguage } from '../../i18n/LanguageContext';

const AdminLayout: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static">
        <Toolbar>
          <Button
            color="inherit"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate('/app/profile')}
            sx={{ mr: 2 }}
          >
            {t.profile}
          </Button>
          <Typography variant="h6" sx={{ flexGrow: 1 }}>
            {t.adminPortalTitle}
          </Typography>
          <Button
            color="inherit"
            startIcon={<PeopleIcon />}
            onClick={() => navigate('/admin/users')}
          >
            {t.adminUsers}
          </Button>
        </Toolbar>
      </AppBar>
      <Box sx={{ flex: 1, p: 2 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default AdminLayout;
